var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"toggle-icon-button",class:[_vm.buttonStyle, {active: _vm.state}],on:{"click":function($event){$event.stopPropagation();return _vm.toggler()}}},[_c('span',{staticClass:"state-layer"},[(!_vm.state)?_vm._t("init-icon"):_vm._t("active-icon"),(_vm.$slots['icon'])?_vm._t("icon"):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }